import $ from 'jquery';
jQuery.noConflict();

export function positionSidebar() {
    jQuery(document).ready(function ($) {
    if ($('#checkout-progress-wrapper').length) {
        $('.cart.sidebar').addClass('mobile-hide');
    }

      var windowScroll = $(window).scrollTop();
      var windowWidth = $(window).width();
      var thisArticle = $(".leftside");
      var thisSidebar = $(".rightside");
      var container = $(".container");
      var sidebarInner = $("#checkout-progress-wrapper");
      var sidebarHeight = sidebarInner.height();
      var articleHeight = thisArticle.height();
      var articleFromTop = thisArticle.offset().top;
      var containerWidth = container.width();
      var sweetSpot = articleHeight - sidebarHeight;
      var rightOffset = ((windowWidth - containerWidth) / 2);
      // console.log('ss: ' + sweetSpot);
      // console.log('current scroll: ' + windowScroll);
      // console.log('current offset: ' + rightOffset);
      if (windowWidth > 992 && windowWidth <= 1280) {
        // console.log('screen larger than 1024 mobile break');
        //if sidebar has hit the bottom
        if (windowScroll + 100 >= sweetSpot) {
          // console.log('sidebar is at the bottom');
          thisSidebar.css("position", "absolute");
          thisSidebar.css("top", "auto");
          thisSidebar.css("bottom", "50px");
          thisSidebar.css("right", rightOffset);
          thisSidebar.css("width", "100%");
          thisSidebar.css("min-width", "0");
          //Sidebar has not yet hit the bottom
        } else {
          //if scroll has not yet passed the top of the article - should still be absolute
          if (windowScroll + 40 <= articleFromTop) {
            // console.log('Sidebar hasnt passed top of leftside yet');
            thisSidebar.css("top", "4.5rem");
            thisSidebar.css("position", "absolute");
            thisSidebar.css("bottom", "2.5rem");
            thisSidebar.css("right", rightOffset);
            thisSidebar.css("width", "100%");
            thisSidebar.css("min-width", "0");
            //Scroll has passed the top of the article - fix the sidebar
          } else {
            // console.log('let the scrollin begin');
            thisSidebar.css("position", "fixed");
            thisSidebar.css("top", "4.5rem");
            thisSidebar.css("bottom", "auto");
            thisSidebar.css("right", rightOffset);
            thisSidebar.css("width", "auto");
            thisSidebar.css("min-width", "0");
          }
        }
      } else if (windowWidth > 1280) {
           // console.log('screen larger than 1024 mobile break');
        //if sidebar has hit the bottom
        if (windowScroll + 100 >= sweetSpot) {
          // console.log('sidebar is at the bottom');
          thisSidebar.css("position", "absolute");
          thisSidebar.css("top", "auto");
          thisSidebar.css("bottom", "50px");
          thisSidebar.css("right", "0");
          thisSidebar.css("width", "100%");
          thisSidebar.css("min-width", "0");
          //Sidebar has not yet hit the bottom
        } else {
          //if scroll has not yet passed the top of the article - should still be absolute
          if (windowScroll + 40 <= articleFromTop) {
            // console.log('Sidebar hasnt passed top of leftside yet');
            thisSidebar.css("top", "4.5rem");
            thisSidebar.css("position", "absolute");
            thisSidebar.css("bottom", "2.5rem");
            thisSidebar.css("right", "0");
            thisSidebar.css("width", "100%");
            thisSidebar.css("min-width", "322px");
            //Scroll has passed the top of the article - fix the sidebar
          } else {
            // console.log('let the scrollin begin');
            thisSidebar.css("position", "fixed");
            thisSidebar.css("top", "4.5rem");
            thisSidebar.css("bottom", "auto");
            thisSidebar.css("right", rightOffset);
            thisSidebar.css("width", "auto");
            thisSidebar.css("min-width", "0");
          }
        }
  
      }
    });
  }